import { Injectable } from '@angular/core';
import { ImageContent } from 'src/app/models/data/image-content.model';
import { Subject, BehaviorSubject } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map, switchMap, catchError } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { User } from 'src/app/models/data/user.model';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  imageContent!: ImageContent[];
  localUser!: User;
  private images = new Subject<ImageContent[]>();
  private isUploadingSubject = new BehaviorSubject<boolean>(false);
  public isUploading$ = this.isUploadingSubject.asObservable();

  constructor(private http: HttpClient) { }

  addFile(title: string | Blob, isSafe: string | Blob, file: File) {
    this.getUserData();

    let headers = new HttpHeaders({
      token: this.localUser.token,
    });

    const ImageCreateRequest = new FormData();
    ImageCreateRequest.append('title', title);
    ImageCreateRequest.append('isSafe', isSafe);
    ImageCreateRequest.append('file', file);
    
    // Set uploading state to true
    this.isUploadingSubject.next(true);
    
    return this.http
      .post(`${environment.apiUrl}/Images`, ImageCreateRequest, {
        headers: headers,
      })
      .pipe(
        switchMap((res) => {
          console.log(JSON.stringify(res));
          // Refresh images and wait for it to complete before clearing upload state
          return this.getImages().pipe(
            map(() => {
              // Set uploading state to false after getImages completes
              this.isUploadingSubject.next(false);
              return res;
            })
          );
        }),
        catchError((error) => {
          // Set uploading state to false on error
          this.isUploadingSubject.next(false);
          console.error('Upload error:', error);
          throw error;
        })
      );
  }

  getUserData() {
    const user: {
      username: string;
      token: string;
      status: number;
    } = JSON.parse(localStorage.getItem('user') as string);

    this.localUser = user;
  }
  getImages() {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
    });

    return this.http
      .get(`${environment.apiUrl}/Images`, {
        headers: headers,
      })
      .pipe(
        map((res) => {
          this.imageContent = <ImageContent[]>res;
          this.images.next(this.imageContent);
          console.log(JSON.stringify(res));
          return res;
        })
      );
  }

  deleteImage(image: ImageContent) {
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
    });
    return this.http
      .delete(`${environment.apiUrl}/Images/${image.ImageID}`, {
        headers: headers,
      })
      .subscribe((res) => {
        console.log(JSON.stringify(res));
        this.getImages().subscribe();
      });
  }

  editImage(image: ImageContent, imageId: number) {
    let imagee = image;
    console.log(image);
    this.getUserData();
    let headers = new HttpHeaders({
      token: this.localUser.token,
    });
    return this.http
      .put(`${environment.apiUrl}/Images/${imageId}`, imagee, {
        headers: headers,
      })
      .pipe(
        switchMap((res) => {
          console.log(JSON.stringify(res));
          return this.getImages();
        }),
      );
  }
  getImagesObs() {
    return this.images.asObservable();
  }
}
